export default {
  'memberMgr.member': 'Member',
  'memberMgr.searchPlaceholder': 'Department Name / Number',
  'memberMgr.serviceNumber': 'Service Number',
  'memberMgr.type': 'Type',
  'memberMgr.role': 'Role',
  'memberMgr.account': 'Account',
  'memberMgr.subscriptionPlan': 'Subscription Plan',
  'memberMgr.state': 'State',
  'memberMgr.lineStatus': 'Line Status',
  'memberMgr.joinDate': 'Join Date',
  'memberMgr.service': 'Service',
  'memberMgr.basicInformation': 'Basic Information',
  'memberMgr.resource': 'Resource',
  'memberMgr.balanceShare': 'Balance Share',
  'memberMgr.active': 'Active',
  'memberMgr.twoBlock': 'Two-Way Block',
  'memberMgr.oneBlock': 'One-Way Block',
  'memberMgr.termination': 'Termination',
  'memberMgr.inactive': 'Inactive',
  'memberMgr.customerName': 'Customer Name',
  'memberMgr.agreementPeriod': 'Agreement Period',
  'memberMgr.invoiceCycleType': 'Invoice Cycle Type',
  'memberMgr.language': 'Language',
  'memberMgr.paidFlag': 'Paid flag',
  'memberMgr.stateTime': 'State Time',
  'memberMgr.numberType': 'Number Type',
  'memberMgr.numberGrade': 'Number Grade',
  'memberMgr.ICCID': 'ICCID',
  'memberMgr.IMSI': 'IMSI',
  'memberMgr.PIN1': 'PIN1',
  'memberMgr.PIN2': 'PIN2',
  'memberMgr.PUK1': 'PUK1',
  'memberMgr.PUK2': 'PUK2',
  'memberMgr.simType': 'SIM Type',
  'memberMgr.templateName': 'Template Name',
  'memberMgr.balanceType': 'Balance Type',
  'memberMgr.cycleLimit': 'Cycle Limit',
  'memberMgr.validLimit': 'Valid Limit',
  'memberMgr.usedLimit': 'Used Limit',
  'memberMgr.effectiveTime': 'Effective Time',
  'memberMgr.expDateTime': 'ExpDate Time',
  'memberMgr.unsubscribe': 'Unsubscribe',
  'memberMgr.unsubscribeTip': 'Are you sure unsubscribe the offer?',
  'memberMgr.unsubscribeSuccess': 'Successfully unsubscribed',
  'memberMgr.memberNumber': 'Member Number',
  'memberMgr.offerName': 'Offer Name',
  'memberMgr.checkResult': 'Check Result',
  'memberMgr.operateSuccess': 'Submit Successfully. WholesaleCode: ',
  'memberMgr.billingAccount': 'Billing Account',
  'memberMgr.memberType': 'Member Type',
  'memberMgr.memberRole': 'Member Role',
  'memberMgr.addSpecialOfferPrivilege': 'Add Special Offer Privilege',
  'memberMgr.remarks': 'Remarks',
  'memberMgr.offerList': 'Offer List',
  'memberMgr.name': 'Name',
  'memberMgr.salePrice': 'One Time Charge({currencySymbol})',
  'memberMgr.rentPrice': 'Monthly Charge({currencySymbol})',
  'memberMgr.dataSpendingLimit': 'Data Spending Limit(MB)',
  'memberMgr.newLanguage': 'New Language',
  'memberMgr.commonSuccess': 'Submit Successfully. Customer Order ID: ',
  'memberMgr.newMsisdn': 'New MSISDN',
  'memberMgr.newMsisdnVaild': 'New MSISDN is not a valid integer',
  'memberMgr.commonoperateSuccess': 'Submit Successfully.',
  'memberMgr.newOfferName': 'New Offer Name',
  'memberMgr.check': 'Check',
  'memberMgr.privateAccount': 'Private Account',
  'memberMgr.success': 'Success',
  'memberMgr.action': 'Action',
  'memberMgr.reason': 'Reason',
  'memberMgr.effectiveDate': 'Effective Date',
  'memberMgr.contactEmail': 'Contact Email',
  'memberMgr.contactNumber': 'Contact Number',
  'memberMgr.paidType': 'Paid Type',
  'memberMgr.expiryDate': 'Expiry Date',
  'memberMgr.autoReactivationDate': 'Auto Re-activation Date',
  'memberMgr.to': 'To',
  'memberMgr.keyword': 'Please enter keyword query',
  'memberMgr.changeNumbers': 'Change Numbers',
  'memberMgr.failed': 'Failed',
  'memberMgr.stateDate': 'State Date',
  'memberMgr.memberList': 'Service Subscription',
  'memberMgr.keyNumber': 'Key Number',
  'memberMgr.form': 'Form',
  'memberMgr.selectServiceNumber': 'Select Service Number',
  'memberMgr.serviceNumbericcid': 'Service Number / ICCID',
  'memberMgr.chooseNewAddress': 'Choose New Address',
  'memberMgr.noData': 'No Data',
  'memberMgr.noDataDesc':
    'The address you entered does not exist. Please click the',
  'memberMgr.noDataDesc1': 'button to submit a ticket for processing',
  'memberMgr.addManually': 'Add Manually',
  'memberMgr.addressDetail': 'Address Detail',
  'memberMgr.addressDetailPlaceholder': 'Enter address detail',
  'memberMgr.streetPlaceholder': 'Select State',
  'memberMgr.newTTOrder': 'New TT Order',
  'memberMgr.ttOrderTips':
    'We have received your installation address, please fill in the service request, we will serve you as soon as possible.',
  'memberMgr.contactName': 'Contact Name',
  'memberMgr.IDType': 'ID Type',
  'memberMgr.IDNumber': 'ID Number',
  'memberMgr.contactNamePlaceholder': 'Enter contact name',
  'memberMgr.contactNumberPlaceholder': 'Enter contact number',
  'memberMgr.IDTypePlaceholder': 'Select ID Type',
  'memberMgr.IDNumberPlaceholder': 'Enter ID number',
  'memberMgr.contactEmailPlaceholder': 'Enter contact email',
  'memberMgr.bundleMember': 'Bundle Member',
  'memberMgr.mainOffer': 'Main Offer',
  'memberMgr.event': 'Event',
  'memberMgr.existingContact': 'Existing Contact',
  'memberMgr.contactFromCurrentOrder': 'Contact from Current Order',
  'memberMgr.newContact': 'New Contact',
  'memberMgr.customerPhone': 'Customer Phone',
  'memberMgr.contact': 'Contact',
  'memberMgr.customerPhone1': 'Customer Phone 1',
  'memberMgr.customerPhone2': 'Customer Phone 2',
  'memberMgr.operation': 'Operation',
  'memberMgr.pleaseInput': 'Please Input',
  'memberMgr.postalCode': 'Postal Code',
  'memberMgr.searchAddress': 'Search address',
  'memberMgr.selectState': 'Select State',
  'memberMgr.selectAddressTips': 'Please select address.',
  'memberMgr.changeBundle': 'Change Bundle',
  'memberMgr.existingSubscriber': 'Existing Subscriber',
  'memberMgr.changeless': 'Changeless',
  'memberMgr.changeOffer': 'Change Offer',
  'memberMgr.pick': 'Pick',
  'memberMgr.joinIn': 'Join in',
  'memberMgr.relocation': 'Relocation',
  'memberMgr.warning': 'Warning',
  'memberMgr.modifyOldBundleMember': 'Modify Old Bundle Member',
  'memberMgr.addNewBundleMember': 'Add New Bundle Member',
  'memberMgr.lowerLimitTip':
    'Bundle unit [{memberAlias}] has lower limit number of member: {lowerLimit}',
  'memberMgr.upperLimitTip':
    'Bundle unit [{memberAlias}] has upper limit number of member: {upperLimit}',
  'memberMgr.pleaseSelectOffer': 'Please select offer',
  'memberMgr.changePlan': 'Change Plan',
  'memberMgr.newNumber': 'New Number',
  'memberMgr.newNumberTip':
    'Relocating to a new location in a different service area requires changing your current fixed line number. Please select a new number from the options below.',
  'memberMgr.subscriptionInformation': 'Subscription Information',
  'memberMgr.installationAddress': 'Installation Address',
  'memberMgr.newMainOffer': 'New Main Offer',
  'memberMgr.last4FuzzySearch': ' Last 4 Fuzzy Search',
  'memberMgr.accurateSearch': 'Accurate Search',
  'memberMgr.previous': 'Previous',
  'memberMgr.next': 'Next',
  'memberMgr.skipTip':
    'The address is not suitable for the current plan, you need change a upper speed plan.',
  'memberMgr.skip': 'Skip',
  'memberMgr.isBundleMember': 'Is Bundle Member',
  'memberMgr.isSameAddress':
    "{msisdn} cannot join the bundle as {msisdn}'s address is different from the bundle offer's address",
  'memberMgr.isSameServtype':
    'The members of the old bundle do not have an available package of the same service type in the new bundle, and therefore cannot be accepted.',
  'memberMgr.agreementEffDate': 'Contract Start Date',
  'memberMgr.agreementExpDate': 'Contract End Date',
  'memberMgr.agreementLimit': 'Contract Term',
  'memberMgr.chooseState':
    'Please select state first and then perform the address search.',
  'memberMgr.validsuspendautoDateToday':
    'Auto Re-activation Date must be later than today',
  'memberMgr.validsuspendeffDateToday':
    'Effective Date must be today and later',
  'memberMgr.validsuspendautoDateEffDate':
    'Effective date must be earlier than Auto Re-activation Date',
  'memberMgr.used': 'Used',
  'memberMgr.remaining': 'Remaining',
  'memberMgr.expires': 'Expires',
  'memberMgr.usage': 'Usage',
  'memberMgr.suspensionUnderRequest': 'Suspension Under Request',
  'memberMgr.simCardLost': 'SIM Card Lost',
  'memberMgr.reactivationUnderRequest': 'Reactivation Under Request',
  'memberMgr.simCardRestore': 'SIM Card Restore',
  'memberMgr.feeInfo':
    'Please take note that a fee of {currencySymbol}{formatAmount} will apply for service reactivation.',
  'memberMgr.newSIMType': 'New SIM Type',
  'memberMgr.simSerialNumber': 'SIM Serial Number',
  'memberMgr.orderReason': 'Order Reason',
  'memberMgr.physicalSIM': 'Physical SIM',
  'memberMgr.agreementInfo':
    'The business can not proceed because the agreement of {offerName} is not completed',
  'memberMgr.unlimited': 'Unlimited',
  'memberMgr.selectTargetOffer': 'Select Target Offer',
  'memberMgr.changeTargetOffer': 'You can change target offer.',
  'memberMgr.currentOffer': 'Current Offer',
  'memberMgr.newOffer': 'New Offer',
  'memberMgr.agreement': 'Agreement',
  'memberMgr.agreementName': 'Agreement Name',
  'memberMgr.effectivePeriod': 'Effective Period',
  'memberMgr.InsufficientMember': 'Insufficient members, please join',
  'memberMgr.addBundleMember': 'Add Bundle Member',
  'memberMgr.addBundleMemberRequired': 'Required',
  'memberMgr.addBundleMemberInValid': 'Illegal number of members',
  'memberMgr.addBundleMemberInValidMore':
    'The old bundle member service type does not exist in the new bundle and cannot be accepted.',
  'memberMgr.addBundleMemberInValidPleaseSelectOffer': 'Please select offer',
  'memberMgr.offerDetail': 'Offer Detail',
  'memberMgr.createDemand': 'Create Demand Case',
  'memberMgr.latitude': 'Latitude',
  'memberMgr.longitude': 'Longitude',
  'memberMgr.demandModalTip':
    'Sorry, currently there are no available ports. Join our waiting list, and we will update you via the Unifi app within 7-14 days.',
  'memberMgr.close': 'Close',
  'memberMgr.joinWaitList': 'Join Waitlist',
  'memberMgr.longitude.error': 'Please enter the correct longitude.',
  'memberMgr.latitude.error': 'Please enter the correct latitude.',
  'memberMgr.infeastructure':
    'The address infrastructure is currently being created and order creation is not allowed.',
  'memberMgr.demandCaseTip1': 'Demand Case created by other operators.',
  'memberMgr.demandCaseTip2':
    'The current Demand Case found does not belong to this customer and cannot be accepted.',
  'memberMgr.joinBundle': 'Join Bundle',
  'memberMgr.additionalInformation': 'Additional Information',
  'memberMgr.postAddress': 'Post Address',
  'memberMgr.country': 'Country',
  'memberMgr.postcode': 'Postcode',
  'memberMgr.city': 'City',
  'memberMgr.address': 'Address',
  'memberMgr.malaysia': 'Malaysia',
  'memberMgr.add.address': 'Add Address',
  'memberMgr.postcodeValid': 'Please enter a 5-digit number postcode.',
  'memberMgr.postcodeResult': 'Postcode does not exist',
  'memberMgr.installationType': 'Installation Type',
  'memberMgr.rushOrder': 'Rush Order',
  'memberMgr.appointmentTime': 'Appointment Time',
  'memberMgr.alternateContactNumber': 'Alternate Contact Number',
  'memberMgr.allternateContactPhone': 'Alternate Contact Phone',
  'memberMgr.noAvailableDeliveryType': 'No available delivery type',
  'memberMgr.selectContactPhone':
    'Must be a number and be between 5-16 digits in length',
  'memberMgr.join': 'Join',
  'memberMgr.streetType': 'Street Type',
  'memberMgr.streetName': 'Street Name',
  'memberMgr.section': 'Section',
  'memberMgr.buildingName': 'Building Name',
  'memberMgr.floorNo': 'Floor No',
  'memberMgr.unit': 'Unit',
  'memberMgr.addressName': 'Address Name',
  'memberMgr.emptyDataDesc':
    ' Please select the state and fill the key words to find your installation address',
  'memberMgr.addManuallyDesc1':
    'Having trouble locating your address? Please fill in your information',
  'memberMgr.addManuallyDesc2': "and we'll get in touch with you.",
  'memberMgr.here': 'here',
  'memberMgr.vdslDesc':
    "Sorry, this address is currently unavailable for online application. Please leave your details and we'll get in touch with you.",
  'memberMgr.changeBundleOfferTitle': 'Bundle Description',
  'memberMgr.bundleBroadbandName': 'Unifi Business Broadband',
  'memberMgr.bundleMobileName': 'Unifi5G Business Mobile',
  'memberMgr.bundleTvName': 'Unifi Business TV',
  'memberMgr.bundleVoiceName': 'Business Voice/Phone Line',
  'memberMgr.bundleDigitalSolution': 'Digital Solution',
  'memberMgr.quantity': 'Quantity',
  'memberMgr.description': 'Offer Description',
  'memberMgr.addressWithSameOriginalAddress':
    'The current selected address is consistent with the original address',
  'memberMgr.oneTimeCharge': 'One Time Charge(Charge to Bill)',
  'memberMgr.monthlyCharge': 'Monthly Charge({currencySymbol})',
  'memberMgr.monthlyChargeTitle': 'Monthly Charge',
  'memberMgr.oneTimeChargeSymbol': 'Total OTC({currencySymbol})',
  'memberMgr.accountItemType': 'Account Item Type',
  'memberMgr.listPrice': 'List Price({currencySymbol})',
  'memberMgr.notAcceptOffer': 'Current main offer can not accept Change Offer.',
  'memberMgr.changeBundleOffer': 'Change Bundle Offer',
  'memberMgr.relocateUnableToTargetAddress':
    'Unable to relocate to the target address.',
  'memberMgr.inStock': 'In Stock',
  'memberMgr.limitedStock': 'Limited Stock',
  'memberMgr.outStock': 'Out of Stock',
  'memberMgr.usagedigitalSolutions':
    'Kindly click {here} to view your digital solutions usage.',
  'memberMgr.createTicket': 'Create Ticket',
  'memberMgr.totalRCForThisOrder': 'Total RC For This Order',
  'memberMgr.monthlyAddon': 'Monthly Add-on({currencySymbol})',
  'memberMgr.newMonthlyBill': 'New Monthly Bill({currencySymbol})',
  'memberMgr.otc': 'OTC',
  'memberMgr.rentalCharge': 'Rental Charge',
  'memberMgr.effectiveType': 'Effective Type',
  'memberMgr.selectOfferPlaceholder': 'Please select offer',
  'memberMgr.effectiveDuration': 'Effective Duration (Date)',
  'memberMgr.feature': 'Feature',
  'memberMgr.orderNumber': 'Order Number',
  'memberMgr.foreignLanguage': 'Foreign Language',
  'memberMgr.networkFlag': 'Network Flag',
  'memberMgr.selectOffer': 'Select Offer',
  'memberMgr.offer': 'Offer',
  'memberMgr.offerGroupName': 'Offer Group Name',
  'memberMgr.bundleMemberManagement': 'Bundle Member Management',
  'memberMgr.currentInformation': 'Current Information',
  'memberMgr.modified': 'Modified',
  'memberMgr.unchanged': 'Unchanged',
  'memberMgr.newSubscriber': 'New Subscriber',
  'memberMgr.featureInformation': 'Feature Information',
  'memberMgr.newMember': 'New Member',
  'memberMgr.addNewConnection': 'New Connection',
  'memberMgr.newConnection': 'New Connection',
  'memberMgr.newSelectMsisdn': 'Select MSISDN',
  'memberMgr.additionalAttribute': 'Additional Attribute',
  'memberMgr.oldSIMCard': 'Old SIM Card',
  'memberMgr.newSIMCard': 'New SIM Card',
  'memberMgr.skuName': 'SKU Name',
  'memberMgr.deviceList': 'Device List',
  'memberMgr.customDeliveryMethod': 'Custom Delivery Method',
  'memberMgr.deliveryMethod': 'Delivery Method',
  'memberMgr.iccidSN': 'ICCID/SN',
  'memberMgr.deliveryInformation': 'Delivery Information',
  'memberMgr.feeInformation': 'Fee Information',
  'memberMgr.activationTips':
    'You can manually enter service number that needs to change the status.',
  'memberMgr.activationEntericcid':
    'Please enter iccid, multiple iccids can be separated and entered',
  'memberMgr.activationiccidError': 'Invalid ICCID',
  'memberMgr.activationSuccess': 'Batch activation successfully',
  'memberMgr.occurrence': 'Occurrence',
  'memberMgr.shareViaWhatsApp': 'Share via WhatsApp',
  'memberMgr.courier': 'Courier',
  'memberMgr.simreplacement.differentCardType':
    'Please select members of the same card type',
  'memberMgr.selectedActiveType': 'Please select members of the activation type',
  'memberMgr.selectedSuspendType': 'Please select members of the Two-Way Block type',
};
